import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.Phone}-enter {
		.${Layouts.Phone} {
			transform: translate(0, 100%);

			.screen-mask {
				opacity: 1;
				transition: opacity 0.3s ease 0.1s;
			}
		}
	}

	&.${Layouts.Phone}-enter-active, &.${Layouts.Phone}-exit {
		.${Layouts.Phone} {
			transform: translate(0, 0);

			.screen-mask {
				opacity: 0;
				transition: opacity 0.3s ease 0.1s;
			}
		}
	}

	&.${Layouts.Phone}-enter-done {
		.${Layouts.Phone} {
			transform: none;

			.screen-mask {
				opacity: 0;
				transition: opacity 0.3s ease 0.1s;
			}
		}
	}

	&.${Layouts.Phone}-exit-active {
		.${Layouts.Phone} {
			transform: translate(0, 100%);

			.screen-mask {
				opacity: 1;
				transition: opacity 0.2s ease;
			}
		}
	}
`;
